import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Link, ResponsiveImage } from "@quintype/components";
import { CollectionName } from "../../atoms/collection-name";
import getStoriesByCollection, { getHeroImage } from "../../../utils";
import { Headline } from "../../atoms/headline";
import Authors from "../../atoms/authors";

import "./comics-section-page.m.css";

const FirstStory = ({ story, config }) => {
  const getLabel = get(story, ["metadata", "story-attributes", "storyattribute", 0], "");
  const heroS3Key = getHeroImage(story, config);
  return (
    <div styleName="first-story-wrapper">
      <div styleName="img-wrapper">
        <Link href={story.url} styleName="hero-image" className="hero-image">
          <figure className="figure-wrapper">
            <ResponsiveImage
              slug={heroS3Key}
              metadata={story["hero-image-metadata"]}
              aspectRatio={[195, 260]}
              defaultWidth={173}
              widths={[173, 265]}
              sizes="( max-width: 500px ) 98%, ( max-width: 768px ) 48%, 23%"
              imgParams={{ auto: ["format", "compress"] }}
              className="responsive-img"
            />
          </figure>
        </Link>
        {getLabel && <div styleName="ribbon">{getLabel}</div>}
      </div>
      <div styleName="first-story-text">
        <Headline story={story} externalLink={true} headlineColor="#fff" />
        <Authors story={story} authorColor="#fff" />
        <Link href={story.url} styleName="comic-btn">
          View Comic
        </Link>
      </div>
    </div>
  );
};

FirstStory.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object
};

const ComicCard = ({ story, config }) => {
  const heroS3Key = getHeroImage(story, config);
  return (
    <div styleName="card-container">
      <Link href={story.url} styleName="hero-image" className="hero-image">
        <figure className="figure-wrapper">
          <ResponsiveImage
            slug={heroS3Key}
            metadata={story["hero-image-metadata"]}
            aspectRatio={[265, 354]}
            defaultWidth={173}
            widths={[173, 265]}
            sizes="( max-width: 500px ) 98%, ( max-width: 768px ) 48%, 23%"
            imgParams={{ auto: ["format", "compress"] }}
            className="responsive-img"
          />
        </figure>
      </Link>
      <div styleName="comic-text">
        <Headline story={story} externalLink={true} />
        <Authors story={story} />
      </div>
    </div>
  );
};

ComicCard.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object
};

const ComicsSectioPage = props => {
  const collection = get(props, ["data", "collection"], {});
  const stories = getStoriesByCollection(collection) || [];
  return (
    <>
      <header styleName="header" className="full-width-with-padding">
        <div styleName="wrapper" className="full-width-with-padding">
          <div className="container" styleName="container">
            <div styleName="collection-text">
              <CollectionName collection={collection} color="#fff" borderBottomColor="#fff" />
              <div styleName="summary">{get(collection, ["summary"], "")}</div>
            </div>
            {stories.slice(0, 1).map(story => (
              <FirstStory story={story} key={story.id} config={get(props, ["config"], {})} />
            ))}
          </div>
        </div>
      </header>
      {stories.length === 0 ? (
        <div styleName="error-msg">No Stories found</div>
      ) : (
        <div styleName="comic-card-wrapper" className="full-width-with-padding">
          <div className="container" styleName="comic-container">
            {stories.slice(1).map(story => (
              <ComicCard story={story} key={story.id} config={get(props, ["config"], {})} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ComicsSectioPage;
